import {
  IonButton,
  IonHeader,
  IonIcon,
  IonItem,
  IonProgressBar,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/react';
import React from 'react';

// import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { chevronBackOutline } from 'ionicons/icons';

import './Navigation.scss';
import { NavigationProps } from './types';

const Navigation: React.FC<NavigationProps> = ({
  title,
  startIcon = chevronBackOutline,
  onBack,
  endButton,
  isLoading = false,
  totalSteps,
  currentStep,
  isCompleted = false,
  showBackButton = true,
}) => {
  const { goBack } = useIonRouter();

  const handleOnBack = async () => {
    // Vibración ligera al presionar back
    // await Haptics.impact({ style: ImpactStyle.Light });

    // Lógica de navegación
    if (onBack) {
      onBack();
    } else {
      goBack();
    }
  };

  const isLastStep = currentStep === totalSteps;

  const progressValue =
    currentStep && totalSteps && totalSteps > 0
      ? isCompleted
        ? 1
        : isLastStep
          ? 0.9
          : currentStep / totalSteps
      : undefined;

  return (
    <IonHeader className="navigation ion-no-border">
      {isLoading && <IonProgressBar type="indeterminate" />}
      {progressValue !== undefined && <IonProgressBar value={progressValue} />}
      <IonToolbar>
        <IonItem lines="none">
          {showBackButton && (
            <IonButton onClick={handleOnBack} slot="start" fill="clear">
              <IonIcon icon={startIcon} color="dark" />
            </IonButton>
          )}
          {title && <IonTitle>{title}</IonTitle>}
          {endButton}
        </IonItem>
      </IonToolbar>
    </IonHeader>
  );
};

export default React.memo(Navigation);
